import EFArrowRight from 'elem/ui-assets/icons/common/EFArrowRight';
import EFAmazon from 'elem/ui-assets/icons/unregular/EFAmazon';
import EfEmarsysEmail from 'elem/ui/ef-emarsys-email';
import EfImg from 'elem/ui/ef-img';
import EfLink from 'elem/ui/ef-link';
import EfSpec from 'elem/ui/ef-spec';
import EfTitle from 'elem/ui/ef-title';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { useProductStore } from './../../../ProductProvider';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';

export default function TheComp() {
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();
    const { t } = useLang('delta3series');
    const locale = useRouter().locale as 'us' | 'ca' | 'br' | 'mx';
    const { pageStatus } = useProductStore();

    const date = new Date(systemTime);
    // 格式化时间
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;

    const configs = {
        className: 'email-box',
        needTerms: true,
        termsHtml: (() => {
            const obj: any = {
                us: "I consent to the <a href='https://us.ecoflow.com/policies/terms-of-service' target='_blank'>Terms of Use</a> and <a href='https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html' target='_blank'>Privacy Policy</a>.",
                ca: "I consent to the <a href='https://ca.ecoflow.com/policies/terms-of-service' target='_blank'>Terms of Use</a> and <a href='https://account.ecoflow.com/agreement/en-ca/PrivacyPolicy.html' target='_blank'>Privacy Policy</a>.",
                br: `Eu concordo com os <a href="https://account.ecoflow.com/agreement/pt-br/TermsOfUse.html" target="_blank">Termos de Uso</a> e a <a href="https://account.ecoflow.com/agreement/pt-br/PrivacyPolicy.html" target="_blank">Política de Privacidade</a>.`,
            };
            return obj[locale] || obj.us;
        })(),
        tipsObj: {
            btnText: t('NA2_email_btn'),
            placeholder: t('NA2_email_placeholder'),
            tipsEmpty: 'Please enter the email.',
            tipsTypeError: 'Please enter a valid email address.',
            successTips: 'Subscription successful !',
            tipsCheck: 'Please consent to the Terms of Use and Privacy Policy.',
            tipsFailed: 'Failed, please try again or contact us.',
        },
        isMulti: true,
        contactListId: ['2135639006', '1157235157'],
        fields: [
            {
                id: '11149',
                type: 'text',
                overwrite: true,
                value: dateString,
            },
            {
                id: '11150',
                type: 'multiple',
                value: [1],
                overwrite: false,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: locale === 'ca' ? '4424' : locale === 'us' ? '4423' : '', // ca + us
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '9435',
                type: 'multiple',
                value: [15],
                overwrite: false,
            },
        ],
    };

    const items = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724664509944/aa3.png',
            title: t('NA2_item1_title'),
            learn_more: (() => {
                const links: any = {
                    us: 'https://us.ecoflow.com/products/delta-3-series-portable-power-station?variant=41631662145609',
                    ca: 'https://ca.ecoflow.com/products/delta-3-series-portable-power-station?variant=45159091077274',
                };
                return links[locale] || `https://${locale}.ecoflow.com/products/delta-3-plus-portable-power-station`;
            })(),
            view_more: (() => {
                const links: any = {
                    us: 'https://www.amazon.com/dp/B0DCC2BVFW?maas=maas_adg_439B31F40B38C50998CC63355B0A5EDB_afap_abs&ref_=aa_maas&tag=maas',
                    ca: 'https://www.amazon.ca/dp/B0DBVLNJRX?maas=maas_adg_4F34043CDCCDA927A8F31FFAD11D3501_afap_abs&ref_=aa_maas&tag=maas',
                };
                return links[locale] || '';
            })(),
            variantId: (() => {
                const LocalMap: any = {
                    us: '41631662145609',
                    ca: '45159091077274',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
        },
        {
            img:
                locale === 'ca'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1724998588798/D3p%2B220W%20PSP%20(1).png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1725246188121/D3p%2B220W%20PSP%20(1).png',
            title: t('NA2_item2_title'),
            learn_more: (() => {
                const links: any = {
                    us: 'https://us.ecoflow.com/products/delta-3-series-solar-generator-pv220w?variant=41637562908745',
                    ca: 'https://ca.ecoflow.com/products/delta-3-series-solar-generator-pv160w?variant=45175494443162',
                    mx: 'https://mx.ecoflow.com/products/ecoflow-delta-3-plus-portable-power-station-220w-portable-solar-panel',
                };
                return links[locale] || `https://${locale}.ecoflow.com/products/delta-3-series-solar-generator-pv220w`;
            })(),
            view_more: (() => {
                const links: any = {
                    us: 'https://www.amazon.com/dp/B0DCBYWVTK?maas=maas_adg_58EF751CA98C60D084F49352D715F345_afap_abs&ref_=aa_maas&tag=maas',
                    ca: 'https://www.amazon.ca/dp/B0DCJS369B?maas=maas_adg_D0D9C8BAAB376119F5C47DE64D3FDD1E_afap_abs&ref_=aa_maas&tag=maas',
                };
                return links[locale] || '';
            })(),
            variantId: (() => {
                const LocalMap: any = {
                    us: '41637562908745',
                    ca: '45175494443162',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
        },
    ];

    const cards = useMemo(() => {
        // 换新
        const Trade_In = {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724664784243/dd3.png',
            title: t('NA2_card1_title'),
            desc: t('NA2_card1_desc'),
            link_more: ['br', 'mx'].includes(locale) ? '' : `https://www.ecoflow.com/${locale}/trade-in`,
        };
        // 价格保证
        const Price_Guarantee = {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724664784107/dd2.png',
            title: t('NA2_card2_title'),
            desc: t('NA2_card2_desc'),
        };
        // 免费安装
        const Free_Installation = {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724836517573/ccc4.png',
            title: t('NA2_card3_title'),
            desc: t('NA2_card3_desc'),
        };
        // 保修
        const Warranty = {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724665243200/dd2.png',
            title: t('NA2_card4_title'),
            desc: t('NA2_card4_desc'),
        };

        let arr;
        if (pageStatus === 'statusD') {
            arr = [Trade_In, Free_Installation, Warranty];
        } else {
            if (locale === 'ca') {
                arr = [Price_Guarantee, Warranty];
            } else {
                arr = [Trade_In, Price_Guarantee, Free_Installation];
            }
        }
        return arr;
    }, [locale, t, pageStatus]);

    const title = useMemo(() => {
        switch (pageStatus) {
            case 'statusA': {
                return t('NA2_titleA');
            }
            case 'statusB': {
                return t('NA2_titleB');
            }
            case 'statusC': {
                return t('NA2_titleC');
            }
            default: {
                return t('NA2_titleD');
            }
        }
    }, [t, pageStatus]);

    return (
        <div className={styles.TheComp}>
            <div className="inner">
                <EfSpec className="spec-m" />
                <EfTitle>{title}</EfTitle>
                {pageStatus === 'statusA' && <EfEmarsysEmail {...configs} />}
                <ul className="items">
                    {items?.map((item, k: number) => (
                        <li className="item" key={k}>
                            <div className="item-img">
                                <EfImg pc={item.img} />
                            </div>
                            <div className="item-info">
                                <p className="item-title">{item.title}</p>
                                {pageStatus !== 'statusA' && (
                                    <div className="item-links">
                                        {['statusB', 'statusC', 'statusD'].includes(pageStatus) && (
                                            <EfLink
                                                href={item?.learn_more}
                                                dataLayer={{
                                                    event: 'uaEvent',
                                                    event_name: 'buy',
                                                    product_name: item.title,
                                                    position: t('common_preorder'),
                                                }}
                                            >
                                                {t('common_preorder')}
                                            </EfLink>
                                        )}
                                        {['statusE'].includes(pageStatus) && (
                                            <EfLink
                                                href={`https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`}
                                                dataLayer={{
                                                    event: 'uaEvent',
                                                    event_name: 'checkout',
                                                    button_name: `${t('common_buy')}_${item.title}`,
                                                }}
                                            >
                                                {t('common_buy')}
                                            </EfLink>
                                        )}
                                        {['statusC'].includes(pageStatus) && (
                                            <EfLink
                                                href={item?.view_more}
                                                className="view-more"
                                                dataLayer={{
                                                    event: 'uaEvent',
                                                    event_name: 'buy_on_amazon',
                                                    product_name: item.title,
                                                    button_name: t('common_view_more'),
                                                    list_name: t('NA2_titleC'),
                                                }}
                                            >
                                                <EFAmazon />
                                                <span className="link-text">{t('common_view_more')}</span>
                                            </EfLink>
                                        )}
                                    </div>
                                )}
                            </div>
                        </li>
                    ))}
                </ul>
                <ul className="cards">
                    {cards?.map((card, k: number) => (
                        <li className="card" key={k}>
                            <div className="card-img">
                                <EfImg pc={card.img} />
                            </div>
                            <p className="card-title">{card.title}</p>
                            <p className="card-desc">{card.desc}</p>
                            {card?.link_more && (
                                <EfLink
                                    className="card-link"
                                    href={card?.link_more}
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'activity_button',
                                        page_name: t('A_title'),
                                        list_name: t('NA2_titleA'),
                                        button_name: t('common_more'),
                                        function: 'Tradein',
                                    }}
                                >
                                    {t('common_more')}
                                    <EFArrowRight />
                                </EfLink>
                            )}
                        </li>
                    ))}
                </ul>
                <EfSpec className="spec-m" />
            </div>
        </div>
    );
}
